(function () {
  'use strict';

  if (customElements.get('read-more-text')) return;

  class ReadMoreText extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-read-more-content]');
      this.toggle = this.querySelector('[data-read-more-toggle]');
      if (!this.content || !this.toggle) return;

      this.moreLabel = this.dataset.readMoreLabel || 'Read more';
      this.lessLabel = this.dataset.readLessLabel || 'Read less';

      this.onToggle = this.onToggle.bind(this);
      this.update = this.update.bind(this);

      this.toggle.addEventListener('click', this.onToggle);

      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this);

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(this.update);
      }
      this.update();
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.toggle) this.toggle.removeEventListener('click', this.onToggle);
    }

    onToggle() {
      const expanded = this.classList.toggle('is-expanded');
      this.toggle.setAttribute('aria-expanded', expanded);
      this.toggle.textContent = expanded ? this.lessLabel : this.moreLabel;
    }

    // Only offer the toggle when the text is actually cut off at the collapsed height.
    update() {
      if (this.classList.contains('is-expanded')) return;
      const isClamped = this.content.scrollHeight - this.content.clientHeight > 1;
      this.toggle.hidden = !isClamped;
    }
  }

  customElements.define('read-more-text', ReadMoreText);
})();
